export const blockedVariations = ["Color", "Finish"] as const;
export const blockedBadges = ["Colors", "Finishes"] as const;
